<script>
    import { langTextStore } from "../store/langtexts.js";
    import { loggedInUserStore } from "../store/loggedInUser.js";
    import { createEventDispatcher } from "svelte";
    export let extraClass = "";
    const dispatch = createEventDispatcher();
    export let langs = [];
    export let showChoice = false;
    function setLang(lang) {
        langTextStore.setLang(lang);
        loggedInUserStore.setLang(lang);
        showChoice = false;
        dispatch("langChosen", { lang });
    }
    function showChoices() {
        showChoice = !showChoice;
    }
</script>

<div class="lang-switcher {extraClass}">
    <span
        on:click={showChoices}
        class="selector {showChoice ? 'selected' : ''}"
    >
        <span class="font-weight-bold me-2"
            >{$langTextStore.getText("general-label-current-lang")}</span
        >
        {$langTextStore.langName}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style="margin-bottom:-1px;"
            width="10"
            height="10"
            fill="currentColor"
            class="showChoicems-1 bi bi-chevron-down text-gray-5 "
            viewBox="0 0 16 16"
        >
            <path
                fill-rule="evenodd"
                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
        </svg>
    </span>
    {#if showChoice}
        {#if langs}
            <div class="lang-switcher--choices">
                {#each langs as lang}
                    <span
                        on:click={() => setLang(lang)}
                        class="d-block mb-1 choice c-pointer"
                    >
                        {#if $langTextStore.langName === lang.langName}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="10"
                                fill="currentColor"
                                class="me-2 bi bi-circle-fill"
                                viewBox="0 0 16 16"
                                ><circle cx="8" cy="8" r="8" /></svg
                            >
                        {:else}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="10"
                                fill="currentColor"
                                class="me-2 bi bi-circle"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                                />
                            </svg>
                        {/if}
                        {lang.langName}
                    </span>
                {/each}
            </div>
        {/if}
    {:else}
        <!--{$langTextStore.getText('general-label-current-lang')}:-->
        <!--{$langTextStore.getText("general-labels-choose-language")}-->
    {/if}
</div>
